<template>
  <div>
    <!-- Botão flutuante do WhatsApp -->
    <button
      class="whatsapp-button"
      @click="showModal = true"
      title="Fale conosco no WhatsApp"
      aria-label="Abrir chat no WhatsApp"
    >
      <i class="fab fa-whatsapp"></i>
    </button>

    <!-- Modal que será exibido ao clicar no botão -->
    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <h3>Fale Conosco!</h3>
        <p>{{ message }}</p>
        
        <div class="modal-actions">
          <a
            :href="whatsappLink"
            target="_blank"
            rel="noopener noreferrer"
            class="btn-whatsapp"
          >
            Falar no WhatsApp
          </a>
          <button class="btn-close" @click="showModal = false">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhatsAppButton',

  data() {
    return {
      showModal: false,

      phoneNumber: null,
      message: null,

      empreendimentos: {
        "porto-atlantico": {
          match: "porto-atlantico",
          nome: "Porto Atlântico",
          phone: "5581994020883",
          mensagem: "Olá! Gostaria de mais informações sobre o empreendimento Porto Atlântico."
        },
        "novo-mundo-empresarial": {
          match: "novo-mundo-empresarial",
          nome: "Novo Mundo Empresarial",
          phone: "5581994020883",
          mensagem: "Olá! Gostaria de mais informações sobre o empreendimento Novo Mundo Empresarial."
        }
      }
    };
  },

  computed: {
    whatsappLink() {
      if (!this.phoneNumber || !this.message) return "#";
      return `https://wa.me/${this.phoneNumber}?text=${encodeURIComponent(this.message)}`;
    }
  },

  methods: {
    closeModalOnEsc(event) {
      if (event.key === 'Escape') {
        this.showModal = false;
      }
    },

    updateEmpreendimentoData() {
      const slug = this.$route.params.slug || "";
      const slugLower = slug.toLowerCase();

      // Verifica Porto Atlântico
      if (slugLower.includes(this.empreendimentos["porto-atlantico"].match)) {
        const emp = this.empreendimentos["porto-atlantico"];
        this.phoneNumber = emp.phone;
        this.message = emp.mensagem;
        return;
      }

      // Verifica Novo Mundo Empresarial
      if (slugLower.includes(this.empreendimentos["novo-mundo-empresarial"].match)) {
        const emp = this.empreendimentos["novo-mundo-empresarial"];
        this.phoneNumber = emp.phone;
        this.message = emp.mensagem;
        return;
      }

      // fallback
      this.phoneNumber = "5581994020883";
      this.message = "Olá! Gostaria de mais informações.";
    }
  },

  mounted() {
    this.updateEmpreendimentoData();
  },

  watch: {
    '$route'() {
      this.updateEmpreendimentoData();
    }
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.closeModalOnEsc);
  }
};
</script>

<style scoped>
/* Estilo do botão flutuante */
.whatsapp-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  color: #fff;
  font-size: 32px;
  background-color: #25d366; /* Cor oficial do WhatsApp */
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease-in-out;
  border: none;
  cursor: pointer;
}

.whatsapp-button:hover {
  transform: scale(1.1);
}

.whatsapp-button i {
  font-size: 40px;
  color: white;
}

/* Estilo do modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Fundo escurecido */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000; /* Acima do botão flutuante */
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.modal-content h3 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
}

.modal-content p {
  font-size: 16px;
  margin-bottom: 20px;
  color: #666;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.btn-whatsapp {
  background-color: #25d366;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.3s;
}

.btn-whatsapp:hover {
  background-color: #1ebe57;
}

.btn-close {
  background-color: #ccc;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s;
}

.btn-close:hover {
  background-color: #999;
}

/* Ajuste para dispositivos móveis */
@media screen and (max-width: 768px) {
  .whatsapp-button {
    bottom: 80px; /* Evita sobreposição com o cookie-law */
    right: 10px;
    width: 50px;
    height: 50px;
  }

  .whatsapp-button i {
    font-size: 30px;
  }

  .modal-content {
    width: 95%;
    padding: 15px;
  }

  .modal-content h3 {
    font-size: 20px;
  }

  .modal-content p {
    font-size: 14px;
  }

  .btn-whatsapp,
  .btn-close {
    padding: 8px 15px;
    font-size: 14px;
  }
}
</style>
